import { useEffect } from "react";
import config from "../../config";

function Logout() {
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      localStorage.removeItem("inventory");
    }
    window.location.href = config.baseUrl;
  }, []);

}

export default Logout;
